import { Head } from '@inertiajs/react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

type PageTitleProps = {
  title: string
  browserTitle?: string // optional title to show in the browser, if different from the on-page title
  children?: React.ReactNode
}

export const PageTitle = ({ title, browserTitle, children }: PageTitleProps) => {
  const browserTitleSuffix = 'Oxford Medical Simulation - VR training for optimal patient care'
  return (
    <>
      <Head title={(browserTitle ?? title) + ' | ' + browserTitleSuffix} />
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, mt: 6, minHeight: '40px' }}>
        <Typography variant="h1" sx={{ flexGrow: 1 }}>
          {title}
        </Typography>
        {children}
      </Box>
    </>
  )
}
